import React, { useState } from 'react';

function TransferOwnershipModal({ 
  show, 
  onClose, 
  workspace, 
  onTransfer 
}) {
  const [selectedMember, setSelectedMember] = useState('');
  const [isTransferring, setIsTransferring] = useState(false);

  if (!show || !workspace) return null;

  // Filter out current owner from members list
  const transferableMembers = workspace.members?.filter(
    m => m.role !== 'owner'
  ) || [];

  const handleTransfer = async () => {
    if (!selectedMember) {
      alert('Please select a member to transfer ownership to');
      return;
    }

    if (!window.confirm(`Are you sure you want to transfer ownership to ${selectedMember}? You will become a regular member.`)) {
      return;
    }

    setIsTransferring(true);
    try {
      await onTransfer(workspace.id, selectedMember);
      onClose();
    } catch (error) {
      alert(error.message || 'Error transferring ownership');
    }
    setIsTransferring(false);
  };

  return (
    <div style={{ 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      right: 0, 
      bottom: 0, 
      backgroundColor: 'rgba(0,0,0,0.5)', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      zIndex: 1000 
    }}>
      <div style={{ 
        background: 'white', 
        borderRadius: '8px', 
        padding: '24px', 
        maxWidth: '450px', 
        width: '90%' 
      }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#1d2934', marginBottom: '8px' }}>
          Transfer Ownership
        </h2>
        <p style={{ color: '#5e778a', fontSize: '14px', marginBottom: '20px' }}>
          Transfer ownership of <strong>{workspace.name}</strong> to another member. You will become a regular member after transfer.
        </p>

        {transferableMembers.length === 0 ? (
          <div style={{ 
            padding: '20px', 
            background: '#fef3c7', 
            borderRadius: '8px', 
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            <p style={{ color: '#92400e', fontSize: '14px', fontWeight: '600', marginBottom: '12px' }}>
              No members available to transfer ownership
            </p>
            <p style={{ color: '#92400e', fontSize: '13px', margin: 0 }}>
              To transfer ownership:
            </p>
            <ol style={{ color: '#92400e', fontSize: '13px', textAlign: 'left', margin: '12px auto', maxWidth: '280px', paddingLeft: '20px' }}>
              <li style={{ marginBottom: '4px' }}>Click "Copy Invite Link" on the workspace page</li>
              <li style={{ marginBottom: '4px' }}>Share the link with your colleague</li>
              <li style={{ marginBottom: '4px' }}>Once they join, return here to transfer ownership</li>
            </ol>
          </div>
        ) : (
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontSize: '14px', color: '#5e778a', marginBottom: '8px' }}>
              Select New Owner
            </label>
            <select
              value={selectedMember}
              onChange={(e) => setSelectedMember(e.target.value)}
              style={{ 
                width: '100%', 
                padding: '10px', 
                border: '1px solid #e0e0e0', 
                borderRadius: '4px', 
                fontSize: '14px',
                backgroundColor: 'white'
              }}
            >
              <option value="">-- Select a member --</option>
              {transferableMembers.map((member) => (
                <option key={member.user_email} value={member.user_email}>
                  {member.user_email} ({member.role})
                </option>
              ))}
            </select>
          </div>
        )}

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{ 
              padding: '10px 20px', 
              border: '1px solid #e0e0e0', 
              borderRadius: '4px', 
              background: 'white', 
              cursor: 'pointer' 
            }}
          >
            Cancel
          </button>
          {transferableMembers.length > 0 && (
            <button
              onClick={handleTransfer}
              disabled={!selectedMember || isTransferring}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: '4px',
                background: selectedMember && !isTransferring ? '#7c3aed' : '#ccc',
                color: 'white',
                cursor: selectedMember && !isTransferring ? 'pointer' : 'not-allowed'
              }}
            >
              {isTransferring ? 'Transferring...' : 'Transfer Ownership'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default TransferOwnershipModal;